import Vue from "vue";
import Vision from "./VisionComponent.vue";

export function load() {
    const selector = "vision-mission";

    if (!document.querySelector(selector)) {
      return;
    }

    new Vue({
        render: (createElement) =>
          createElement(Vision, {
            props: {
              ...window[selector],
            },
          }),
      }).$mount(selector);
    }

